import { InnerBlocks, RichText } from "@wordpress/block-editor";
import { debug } from '../../utilities/helpers';


function Save({ attributes }) {
  const {
    title = "",
    isOpen = false,
    backgroundColorClass,
    headingId,
    collapseId,
    accordionId
  } = attributes;

  // debug("Accordion Child - Save", { backgroundColorClass, accordionId, headingId, collapseId });

  return (
    <div className={`accordion-item ${backgroundColorClass}`}>
      <div className={`accordion-header ${backgroundColorClass}`}
           id={headingId}
      >
        <button className={`accordion-button collapsed ${backgroundColorClass}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#${collapseId}`}
                aria-expanded={isOpen}
                aria-controls={collapseId}
        >
          <RichText.Content
              tagName="span"
              value={title}
              className={`accordion-title`}
          />
        </button>
      </div>

      <div
          id={collapseId}
          className={`accordion-collapse collapse ${backgroundColorClass}`}
          aria-labelledby={headingId}
          data-bs-parent={`#${accordionId}`}
      >
        <div className="accordion-body accordion-body-white">
            <InnerBlocks.Content />
        </div>
      </div>
    </div>
  );
}

export default Save;
